// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c6Zx","type":"styles_type__2hNd6","choices":"styles_choices__3BqJ0"};